<template>
  <div>
    <div class="relative">
      <textarea
        v-bind="$attrs"
        class="w-full rounded-md border-solid border px-4 py-3"
        :class="{
          'border-EXPONDO-grey-20': valid,
          'border-EXPONDO-red': !valid,
          'pl-5': required
        }"
        :required="required"
        :value="modelValue"
        @input="handleInput"
      />
      <span
        v-if="required"
        class="required-star w-5 flex justify-center absolute top-3 left-0
        cursor-default text-EXPONDO-red"
      >
        *
      </span>
    </div>
    <InputErrorMessage
      :show="showError"
      :message="errorMessage"
      :has-messages="showError"
      test-id="custom-textarea__error-message"
    />
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'CustomTextarea',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    valid: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {

    const showError = computed(() => !props.valid && !!props.errorMessage);

    const handleInput = (event: Event) => {

      const target = event.target as HTMLTextAreaElement | null;
      const nextValue = target?.value ?? '';
      emit('update:modelValue', nextValue);

    };

    return {
      handleInput,
      showError,
    };

  },
});

</script>
